<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div> -->

          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增配置</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column prop="bucketName" label="桶名称" />
        <el-table-column label="secretKey" prop="secretKey" />
        <el-table-column label="地区" prop="endpoint" />
        <el-table-column label="租户名称" prop="tenantName" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination> -->

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="120px"
        >
          <el-form-item label="accessKey" prop="">
            <el-input :min="0" v-model="formData.accessKey"></el-input>
          </el-form-item>
          <el-form-item label="bucketName" prop="">
            <el-input :min="0" v-model="formData.bucketName"></el-input>
          </el-form-item>
          <el-form-item label="endpoint" prop="">
            <el-input :min="0" v-model="formData.endpoint"></el-input>
          </el-form-item>
          <el-form-item label="secretKey" prop="">
            <el-input :min="0" v-model="formData.secretKey"></el-input>
          </el-form-item>

          <el-form-item label="租户" prop="" required>
            <el-select
              v-model="formData.tenantId"
              placeholder="租户"
              clearable
              :disabled="title == '编辑'"
            >
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";
import { tenantInfo } from "@/common/publicApi";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tenantList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        accessKey: "",
        bucketName: "",
        endpoint: "",
        secretKey: "",
        tenantId: "",
      },
    };
  },
  computed: {},
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      api.tenantS3List().then((res) => {
        if (res.code == 0) {
          this.tabList = res.data;
        }
      });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData = JSON.parse(JSON.stringify(row));
        delete this.formData.createdTime;
        delete this.formData.updatedTime;
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        accessKey: "",
        bucketName: "",
        endpoint: "",
        secretKey: "",
        tenantId: "",
      };
      this.title = "";
    },
    handleSave() {
      if (this.formData.accessKey == "") {
        return this.$message.error("请输入accessKey");
      }
      if (this.formData.bucketName == "") {
        return this.$message.error("请输入bucketName");
      }
      if (this.formData.endpoint == "") {
        return this.$message.error("请输入endpoint");
      }
      if (this.formData.secretKey == "") {
        return this.$message.error("请输入secretKey");
      }
      if (this.formData.tenantId == "") {
        return this.$message.error("请选择tenantId");
      }
      console.log("this.formData", this.formData);

      let url = "";
      this.title == "编辑" ? (url = "tenantS3Edit") : (url = "tenantS3Add");
      api[url](this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
